import ListSoldProductsByVendorTable from './ListSoldProductsByVendorTable';

export default ListSoldProductsByVendorTable;
